// extracted by mini-css-extract-plugin
export default {"header":"VilleCCASHeader_header__cBkJt","logo":"VilleCCASHeader_logo__XNhVw"};